export type Video = {
    id: string // YouTube video id
    title: string
    kind: string
}

export const videos: Video[] = [
    { id: 'JjaYYDGZb1s', title: 'Sun City Poms', kind: 'Official video' },
    { id: 'H5AZ6wsdIvA', title: 'Wood For The Trees', kind: 'Official video' },
    { id: 'mwEER0oeTdA', title: 'Avalanche', kind: 'Official video' },
    { id: '-wLtufedyKI', title: 'Liar & Thief', kind: 'Official video' },
    { id: '1MBFpHnLWP0', title: 'Live at Voodoo, Belfast', kind: 'Live — Apr 2025' },
]

export const BANDCAMP_ALBUM_URL = 'https://kenayda.bandcamp.com/album/orphans'
export const EMAIL = 'info@kenayda.com'
